<mat-radio-group [(ngModel)]="type" (ngModelChange)="onChange($event)" [disabled]="disabled">
  <mat-radio-button value="Edificio">{{ 'LABEL.BUILDING' | translate }}</mat-radio-button>
  <mat-radio-button value="Condominio">{{ 'LABEL.CONDOMINIUM' | translate }}</mat-radio-button>
</mat-radio-group>
